import React from "react";

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pagesToShow = 7;
  const half = Math.floor(pagesToShow / 2);
  const startPage = Math.max(1, Math.min(currentPage - half, totalPages - pagesToShow + 1));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  const pages = [];
  for (let page = startPage; page <= endPage; page += 1) {
    pages.push(page);
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className="btn-ghost disabled:opacity-40"
      >
        처음
      </button>
      <button
        type="button"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="btn-ghost disabled:opacity-40"
      >
        이전
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onPageChange(page)}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
            page === currentPage
              ? "bg-brand-500 text-white shadow-glow"
              : "border border-white/10 bg-white/5 text-ink-200 hover:bg-white/10"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="btn-ghost disabled:opacity-40"
      >
        다음
      </button>
      <button
        type="button"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="btn-ghost disabled:opacity-40"
      >
        마지막
      </button>
    </div>
  );
}

export default Pagination;
